import React from 'react';
import PropTypes from 'prop-types';
import LabelTooltip from './label_tooltip';
import { colors } from '../../constants';
import { InformationIcon } from '../../icons';
import { injectDescriptionTheme } from './style_injectors';
import { withTheme } from 'styled-components';

class DescriptionTooltip extends React.Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    interactive: PropTypes.bool,
  };

  static defaultProps = {
    position: 'bottom',
  };

  render() {
    const { theme, text, position, interactive, children } = this.props;

    const DescriptionTheme = injectDescriptionTheme(theme, { width: '200px' });

    return (
      <>
        <DescriptionTheme />
        <LabelTooltip
          theme="information"
          text={text}
          position={position}
          hideOnClick={false}
          interactive={interactive}
        >
          {children || <InformationIcon hoverColor={colors.mediumGrey} />}
        </LabelTooltip>
      </>
    );
  }
}

export default withTheme(DescriptionTooltip);
